import React, { useEffect, useState } from "react";
import { CourseInfo, Filter, FloatRight, FormView, PagesHeader, PriceHistoryModal } from "../../components/Courses";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getCourseFilter, getCourseInfo, getCoursesList } from "../../appRedux/actions/courses";
import Page from "../../components/Common/Page";
import { getFreeCurrencyApi } from "../../appRedux/actions/common";
import { useNavigate, useParams } from "react-router-dom";
const IframeComponent = ({ src, width, height }) => {
  return (
    <iframe
      src={src}
      width={width}
      height={height}
      frameBorder="0"
      allowFullScreen
      sandbox="allow-scripts allow-same-origin"
      title="iframe"
    ></iframe>
  );
};

const CourseDetails = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const courseList = useSelector((state) => state.courses.courseList);
  const selectedCurrency = useSelector((state) => state.common.selectedCurrency);
  const currencyData = useSelector((state) => state.common.currencyData);
  const [isPriceModalVisible, setIsPriceModalVisible] = useState(false);

  useEffect(() => {
    dispatch(getCourseInfo(courseId));
  }, [courseId]);
  useEffect(() => {
    dispatch(getCourseFilter({}));

    dispatch(getFreeCurrencyApi());
  }, [dispatch]);
  return (
    <Page title="Course">
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <PagesHeader
            pageTitle={"Course Details"}
            homePageUrl="/"
            homePageText="Dashboard"
            innerPageUrl={"/course/list"}
            innerPageText={"Course List"}
            activePageText={"Course Details"}
            floatRight={
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  className="btn"
                  onClick={() => setIsPriceModalVisible(true)}
                  style={{
                    backgroundColor: "#e6f7ff",
                    color: "#00A79D",
                    border: "1px solid #00A79D",
                    borderRadius: "5px",
                    fontWeight: 500,
                  }}
                >
                  <i className="fa fa-line-chart" /> Price History
                </button>
                <button
                  className="btn add-btn m-r-5"
                  onClick={() => {
                    navigate(`/course/update/${courseId}`);
                  }}
                >
                  <i className="fa fa-pencil" /> Update Course
                </button>
              </div>
            }
          />
          
          <PriceHistoryModal 
            visible={isPriceModalVisible} 
            onClose={() => setIsPriceModalVisible(false)} 
            courseId={courseId} 
            currencyInfo={{ selectedCurrency, currencyData }}
          />
          <div className="card">
            <div className="card-body">
              <CourseInfo />
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
    </Page>
  );
};

export default CourseDetails;
